<template>
  <div class="row">
    <div v-if="$store.state.hasDiscount" key="NOTICES" class="row">
      <div class="col-sm-12">
        <div data-notify="container" class="col-md-12 alert alert-warning alert-with-icon ">
          <span data-notify="icon" class="fa fa-exclamation"></span>
          <span data-notify="message">SPECIAL OFFER: Complete your application in October and save 10% off the Qualification Check fee. Offer ends 5th of November.</span>
        </div>
      </div>
    </div>
    <step-navigation :steps="steps" :currentStep="currentStep" />
    <transition :enter-active-class="enterAnimation" :leave-active-class="leaveAnimation" mode="out-in" v-on:leave="afterEnter">
      <component 
        :is="currentView" 
        :application="application"
        :loadingInstitutes="loadingInstitutes"
        :initApplication="application"
        :verification="verification != null ? verification : undefined" 
        :verifications="verifications" 
        :permissions="252"
        :previousNames="previousNames"
        :previousInstitutes="previousInstitutes" 
        :documentDeleteData="documentDeleteData"
        :min="0" 
        :inflow="true" 
        :multi="true"
        :additionalDocsAllowed="verification.institute ? (verification.institute.allowsPending ? verification.institute.maxAdditionalDocs : 0) : 5"
        @started="started"
        @saveAndCard="saveAll(() => {currentView = 'pay'})"
        @saveAndPay="saveAll(() => submitAndPay())"
        @cancelStart="currentView = 'pay'"
        @editMulti="currentView = 'multi'"
        @newVerification="newVerification"
        @select="verification.institute = $event; currentView = 'edit'"
        @deleteInstitute="verification.institute = null; currentView = 'iselect'"
        @editVerification="editVerification"
        @deleteVerification="deleteVerification"
        @confirm="currentView = 'pay'"
        @saveForLater="saveForLater($event)" 
        @pay="submitAndPay" 
        @payBack="currentView = 'multi'"
        @back="step = 'SUMMARY'">
        <template slot="actions" slot-scope="props">
          <div v-if="currentView == 'application'" class="col-md-12 card card-plain">
            <button @click.prevent="saveApplication(props.application)" v-bind:disabled="!props.valid" v-bind:class="{'btn-disabled': !props.valid}" type="button" class="btn btn-wd btn-fill btn-move-right pull-right">Next<span class="btn-label"><i class="ti-angle-right"></i></span></button>
          </div>

          <div v-if="currentView == 'iselect'" class="col-md-12 card card-plain">
            <button v-if="verifications.length > 0" @click.prevent="currentView = 'pay'" type="button" class="btn btn-wd btn-fill"><span class="btn-label"><i class="fa fa-times"></i></span>Cancel</button>
          </div>

          <div v-if="currentView == 'edit'" class="col-md-12 card card-plain">
            <small class="text-danger pull-right" v-if="errors.any()">
              Please resolve the errors above.
            </small>
            <br v-if="errors.any()"/>
            <button @click.prevent="saveVerification(props.verification)" v-bind:disabled="!props.valid" v-bind:class="{'btn-disabled': !props.valid}" type="button" class="btn btn-wd btn-fill btn-move-right pull-right">Next<span class="btn-label"><i class="ti-angle-right"></i></span></button>
            <button v-if="verifications.length > 0 && props.verification.new" @click.prevent="currentView = 'pay'" type="button" class="btn btn-wd btn-fill"><span class="btn-label"><i class="fa fa-times"></i></span>Cancel</button>
            <!--<button v-else-if="verifications.length > 1" @click.prevent="deleteVerification(props.verification)" type="button" class="btn btn-wd btn-primary btn-fill"><span class="btn-label"><i class="fa fa-trash"></i></span>Delete</button>-->
          </div>

          <div v-if="currentView == 'order'" class="col-md-12 card card-plain">
            <button v-if="paysNow" @click.prevent="currentView = 'pay'" v-bind:disabled="!props.allTicked" v-bind:class="{'btn-disabled': !props.allTicked}" type="button" class="btn btn-wd btn-fill btn-move-right pull-right">Next<span class="btn-label"><i class="ti-angle-right"></i></span></button>
            <button v-else @click.prevent="submitAndPay" type="button" v-bind:disabled="!props.allTicked" v-bind:class="{'btn-disabled': !props.allTicked}" class="btn btn-wd btn-fill btn-move-right pull-right">Submit<span class="btn-label"><i class="ti-angle-right"></i></span></button>
          </div>
        </template>
      </component>
    </transition>
  </div>
</template>

<script>
  import Start from 'src/views/Verifications/multi/Start'
  import MultiVerification from 'src/views/Verifications/multi/MultiVerification'
  import InstituteSelect from 'src/views/Verifications/components/InstituteSelect'
  import Verification from 'src/views/Verifications/components/Verification'
  import OrderSummary from 'src/views/Verifications/components/OrderSummary'
  import Application from 'src/views/Verifications/components/InflowApplication'
  import Payment from 'src/views/Credit/components/Payment'


  import StepNavigation from 'src/components/Steps/StepNavigation'
  import ModalOptions from 'src/components/ModalPlugin/ModalOptions'

  import { Loading } from 'element-ui';
  import {version} from '../../../../package.json';
  import LogRocket from 'logrocket';

  import accounting from 'accounting'
  import _ from 'lodash'

  export default {
    name: "verification-new",
    components: {
      Loading,
      StepNavigation,
      'start': Start,
      'multi': MultiVerification,
      'iselect': InstituteSelect,
      'edit': Verification,
      'application': Application,
      'order': OrderSummary,
      'pay': Payment
    },
    props: { 
      initApplication: {type: Object, default: null}
    },
    data () {
      return {
        application: this.initApplication,
        verification: null,
        verifications: [],
        currentView: null,
        currentStep: 10,
        previousStep: null,
        loadingInstitutes: false
      }
    },
    watch: {
      currentView(value, oldValue) {
        switch (value) {
          case 'application': 
            this.currentStep = 0
            break
          case 'start': 
            this.currentStep = 10
            break
          case 'multi': 
            this.currentStep = 15
            break
          case 'iselect': 
            this.currentStep = 20
            break
          case 'edit': 
            this.currentStep = 30
            break
          case 'order': 
            this.currentStep = 40
            break
          case 'pay': 
            this.currentStep = 50
            break
        }
        switch (oldValue) {
          case 'application': 
            this.previousStep = 0
            break
          case 'start': 
            this.previousStep = 10
            break
          case 'multi': 
            this.previousStep = 15
            break
          case 'iselect': 
            this.previousStep = 20
            break
          case 'edit': 
            this.previousStep = 30
            break
          case 'order': 
            this.previousStep = 40
            break
          case 'pay': 
            this.previousStep = 50
            break
        }
      },
      verificationsInProgress (value) {
        //this.$store.commit('setVerificationsInProgress', value)
      }
    },
    computed: {
      steps() {
        var steps = []
        
        if(this.application) {
          steps.push({
              id: 0,
              title: "Application Details",
              icon_class: "ti-clipboard"
          })
        }
        if(this.allowedTypes.length > 1) {
          steps.push({
                id: 10,
                title: "Start",
                icon_class: "fa fa-play"
            })
        }
        steps.push({
              id: 15,
              title: "Verification Details",
              icon_class: "fa fa-th-list"
          })
        if(this.$store.state.paymentType == 'CARD') {
          steps.push({
              id: 50,
              title: "Payment Details",
              icon_class: "fa fa-credit-card"
          })
        }
        steps.push({
            id: 60,
            title: "View Result",
            icon_class: "fa fa-graduation-cap"
        })
        return steps;
      },
      enterAnimation() {
        if (this.currentStep < this.previousStep) {
          return "animated fast slideInLeft";
        } else {
          return "animated fast slideInRight";
        }
      },
      leaveAnimation() {
        if (this.currentStep > this.previousStep) {
          return "animated fast slideOutLeft";
        } else {
          return "animated fast slideOutRight";
        }
      },
      pays() {
        if(this.application && !this.application.applicantPays) {
          return false
        } else {
          return (this.$store.state.paymentType == 'CARD' || this.$store.state.paymentType == 'INVOICE')
        }
      },
      paysNow() {
        return this.pays && this.$store.state.paymentType == 'CARD'
      },
      verificationsInProgress() {
        let nonNew = 0
        this.verifications.forEach(function (verification) {
          if(!verification.new) {
            nonNew++
          }
        })
        if(this.verification && this.verification.new) {
          if(this.verification.firstname || this.verification.lastname || this.verification.dob || this.verification.institute) {
            nonNew++
          }
        }
        return nonNew
      },
      previousNames() {
        let names = []
        let ids = []
        this.verifications.forEach(verification => {
          if(!verification.new) {
            let full = verification.firstname + verification.middlename + verification.lastname + verification.dob
            if(!ids.includes(full)) {
              names.push({
                firstname: verification.firstname,
                middlename: verification.middlename,
                lastname: verification.lastname,
                dob: verification.dob,
                full: full
              })
              ids.push(full)
            }
          }
        })
        return names
      },
      previousInstitutes() {
        let institutes = []
        let ids = []
        this.verifications.forEach(function (verification) {
          if(verification.institute) {
            if(!ids.includes(verification.institute.id)) {
              ids.push(verification.institute.id)
              institutes.push(verification.institute)
            }
          }
        })
        return institutes
      },
      allowedTypes() {
        if(this.application != null && this.application.allowedTypes) {
          return JSON.parse(this.application.allowedTypes).map(type => type.key)
        }
        return this.$store.getters.allowedTypes
      }
    },
    created () {
      this.init()
    },
    mounted () {
      // if(this.$store.state.isApplicant && this.$store.state.openApplications > 0 && this.initApplication == null) {
      //     this.$modal.show(ModalOptions,
      //       {
      //         title: "You have open applications",
      //         message: "Do you want to complete your application by submitting a new verification?",
      //         message2: "Or do you want to add a new private verification to your wallet?",
      //         closeText: "Private Wallet",
      //         actionText1: "Complete Application",
      //         closeAction: () => 
      //           {
      //             this.$modal.close()
      //           },
      //         action1: () => 
      //           {
      //             this.$modal.close()
      //             this.$router.push('/applications/open')
      //           }
      //         })
      // }
    },
    deactivated() {
      if (this.step === 'EDIT') {
        if(this.verifications.length > 1 
          && this.verification.new 
          && !this.verification.firstname
          && !this.verification.lastname
          && !this.verification.dob
          && !this.verification.institute) {
            this.deleteVerification(this.verifications.length - 1)
            this.step = 'SUMMARY'
          }
      }
    },
    methods: {
      resetSavedData() {
        this.$store.state.savedVerificationData = {
          dob: "",
          firstName: "",
          lastName: "",
          instituteId: ""
        }
        this.$store.state.previousVerificationData = null
      },
      afterEnter() {
        this.$scrollTo('#contentTop')

      },
      init () {
        LogRocket.track('NewV');
        this.verifications = []
        this.newVerification()
      },
      newVerification (creditPurchaseRequest, callback) {
        if(creditPurchaseRequest && creditPurchaseRequest.btSaveCard) {
           this.$api.postCreditPurchase(creditPurchaseRequest)
            .catch(error => {
              console.log(error)
            })
        }
        this.verification = {
            firstname: null,
            middlename: null,
            lastname: null,
            dob: null,
            institute: null,
            customerReference: null,
            new: true
          }

        if(this.application) {
          if(this.application.lockedInstitutes) {
            this.loadingInstitutes = true
            var promises = []
            this.application.lockedInstitutes.forEach(i => {
              promises.push(this.$service.buildInstitute(i))
            })
            Promise.all(promises)
              .then(responses => {
                responses.forEach(response => {
                  this.verifications.push({
                    firstname: null,
                    middlename: null,
                    lastname: null,
                    dob: null,
                    institute: response,
                    customerReference: null,
                    new: true,
                    type: 'education'
                  })
                })
                this.loadingInstitutes = false
              })
              .catch(error => {
                console.log(error)
                this.loadingInstitutes = false
              })
          } else if(this.allowedTypes.length == 1) {
            switch(this.allowedTypes[0]) {
              case 'edu':
                this.$route.query.nedu = 1
                break;
              case 'hsc':
                this.$route.query.nhsc = 1
                break;
              case 'emp':
                this.$route.query.nemp = 1
                break;
              case 'pli':
                this.$route.query.npli = 1
                break;
              case 'pce':
                this.$route.query.npce = 1
                break;
              case 'idc':
                this.$route.query.nidc = 1
                break;
              default:
                console.warn("Unknown single allowed type, not sure what type to set on verification")
                break;
            }
          }
          this.currentView = 'application'
        } else {
          var nonAppNextView = 'start'
          if(this.$store.state.initInstitute) {
            this.verification.type = 'education'
            this.verification.institute = this.$store.state.initInstitute
            this.$store.commit('setInitInstitute', null)
            this.verifications.push(this.verification)
            nonAppNextView = 'multi'
          } else if(this.allowedTypes.length == 1) {
            switch(this.allowedTypes[0]) {
              case 'edu':
                this.$route.query.nedu = 1
                nonAppNextView = 'multi'
                break;
              case 'hsc':
                this.$route.query.nhsc = 1
                nonAppNextView = 'multi'
                break;
              case 'emp':
                this.$route.query.nemp = 1
                nonAppNextView = 'multi'
                break;
              case 'pli':
                this.$route.query.npli = 1
                nonAppNextView = 'multi'
                break;
              case 'pce':
                this.$route.query.npce = 1
                nonAppNextView = 'multi'
                break;
              case 'idc':
                this.$route.query.nidc = 1
                nonAppNextView = 'multi'
                break;
              default:
                console.warn("Unknown single allowed type, not sure what type to set on verification, dropping back to start!")
                nonAppNextView = 'start'
                break;
            }
          }
          this.currentView = nonAppNextView
        }
      },
      started () {
        this.verification = this.verifications[0]
        // if(this.verification.type == 'employment') {
        //   this.currentView = 'edit'
        // } else {
        //   this.currentView = 'iselect'
        // }
        this.currentView = 'multi'
      },
      saveVerification (verification) {
        this.$validator.validate().then((result) => {
          if(result) {
            if(verification.new) {
              verification.new = false  
              //this.verifications.push(verification)
            }
            this.verification = verification
            this.currentView = 'order'
          } else {
            this.$snotify.error("Please correct the errors shown below.", "Error", {
              timeout: 7500
            })
            this.$scrollTo('#contentTop')
          }
        })
      },
      saveAll (callback) {
        this.$validator.validate().then((result) => {
          if(result) {
            this.verifications.forEach(verification => {
              if(verification.new) {
                  verification.new = false  
                }
            })
            callback()
          } else {
            this.$snotify.error("Please correct the errors shown below.", "Error", {
            timeout: 7500
          })
          this.$scrollTo('#contentTop')
          }
        })
      },
      editVerification(verification) {
        this.verification = verification
        this.currentView = 'edit'
      },
      deleteVerification(index) {
        this.$modal.show(ModalOptions,
          {
            title: "Remove Verification",
            message: "Are you sure you want to delete this verification?",
            closeText: "Cancel",
            actionText1: "Delete",
            actionIcon1: "fa fa-trash",
            action1: () => 
              {
                if(index >= 0) { 
                  this.verifications.splice(index, 1)
                  this.currentView = 'pay'
                }
                this.$modal.close()
              }
            }
          )
      },
      saveApplication(application) {
        if(application.owner.name == 'WES') {
          if(!application.fields[0].value) {
            this.$snotify.error("Please input your WES Reference Number", "Error", {
              timeout: 7500
            })
            return
          }
        }
        this.$validator.validate().then((result) => {
          if(result) {
            var loading = Loading.service({
              spinner: 'qc-spinner',
              text: 'Saving application'
            })
            this.$api.updateApplication(application.id, {fields: application.fields, documents: application.documents})
              .then(response => {
                loading.close()
                this.application = response.data
                this.currentView = this.allowedTypes.length == 1 ? 'multi' : 'start'
                if (this.application.owner.name == 'WES') {
                  var logRocketEnv = null
                  logRocketEnv = 'selective'
                  LogRocket.init('qc/selective', {
                    release: version
                  })
                }
              })
              .catch(error => {
                loading.close()
                console.log(error)
              })
          } else {
            this.$snotify.error("Please correct the errors shown below.", "Error", {
              timeout: 7500
            })
            this.$scrollTo('#contentTop')
          }
        })
      },
      documentDeleteData (document) {
        return new Promise((resolve, reject) => {
          // Nothing to do particularly
          resolve()
        })
      },
      saveForLater(verification) {
        this.$validator.validateAll('fields').then((result) => {
          if(result) {
            var loading = Loading.service({
              spinner: 'qc-spinner',
              text: 'Saving verification for later'
            })
            this.verification = verification

            this.$api.postVerification(this.$service.buildVerificationSubmission(verification, this.application ? this.application.id : null), true)
              .then(response => {
                this.$store.commit('updateMeta')
                if(this.verifications.length <= 0) {
                  this.init()
                  this.pushNext(response.data)
                } else {
                  this.verification = null
                  this.currentView = 'pay'
                }
                loading.close()
                this.$snotify.warning("Verification for " + verification.firstname + " " + verification.lastname + " saved to history.", "Saved", {
                  timeout: 7500,
                  icon: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20version=%221.1%22%20x=%220px%22%20y=%220px%22%20viewBox=%220%200%20512%20512%22%20fill=%22%23ffffff%22%3E%3Cg%3E%3Cpath%20d=%22M256,512c141.15,0,256-114.84,256-256S397.15,0,256,0,0,114.84,0,256,114.85,512,256,512Zm0-480.49c123.79,0,224.49,100.71,224.49,224.49S379.79,480.49,256,480.49,31.51,379.79,31.51,256,132.21,31.51,256,31.51Z%22/%3E%3Ccircle%20cx=%22260.08%22%20cy=%22343.87%22%20r=%2226.35%22/%3E%3Cpath%20d=%22M254.68,278.39a15.76,15.76,0,0,0,15.75-15.75V128.72a15.75,15.75,0,1,0-31.51,0V262.63A15.76,15.76,0,0,0,254.68,278.39Z%22/%3E%3C/g%3E%3C/svg%3E'
                })
              }).catch(error => {
                console.log(error)
                loading.close()
              })
          } else {
            this.$snotify.error("Please correct the errors shown below.", "Error", {
              timeout: 7500
            })
            this.$scrollTo('#contentTop')
          }
        })
      },
      submitAndPay(creditPurchaseRequest, callback) {
        var loading = Loading.service({
          spinner: 'qc-spinner',
          text: 'Submitting verification(s)'
        })

        var dtos = []
        this.verifications.forEach(verification => {
            dtos.push(this.$service.buildVerificationSubmission(verification, this.application ? this.application.id : null))
        })

        this.$api.postVerification({
            verifications: dtos,
            creditPurchase: creditPurchaseRequest
          })
          .then(response => {
            this.$store.commit('updateMeta')
            this.init()
            this.pushNext(response.data)
            loading.close()
          }).catch(error => {
            console.log(error)
            loading.close()
            this.currentView = 'multi'
          })
      },
      pushNext(responseData) {
        var url = this.$store.getters.isNonApplicantIndividual ? '/wallet' : '/verification/history'
        var invoiceId = responseData.length > 0 ? responseData[0].invoiceId : responseData.invoiceId
        if(invoiceId) {
            this.$snotify.success("Invoice " + invoiceId + " has been saved to your invoices history.", "Payment Complete", {
              timeout: 7500,
              icon: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20version%3D%221.1%22%20width%3D%22500%22%20height%3D%22500%22%3E%0A%3Cg%20transform%3D%22translate(0%2C-552.36218)%22%20id%3D%22layer1%22%20%3E%3Cpath%20fill%3D%22%23ffffff%22%20d%3D%22m%20301.29681%2C788.55573%200%2C32.9956%20-81.5918%2C0%20c%205.99351%2C17.19988%208.99033%2C31.20133%208.99048%2C42.0044%20l%200%2C0.60424%20c%20-1.5e-4%2C21.9972%20-11.59682%2C46.79576%20-34.79004%2C74.39576%20-9.20421%2C11.20611%20-21.20371%2C24.20659%20-35.99854%2C39.00146%2023.5961%2C-15.60053%2047.99182%2C-23.40082%2073.18726%2C-23.40088%2014.0013%2C6e-5%2030.40143%2C3.00299%2049.20044%2C9.00879%2021.99685%2C6.39653%2037.79883%2C9.59477%2047.406%2C9.59473%2016.00316%2C4e-5%2032.60471%2C-5.99971%2049.80469%2C-17.99927%20l%2025.19531%2C39.60571%20c%20-22.80303%2C22.39993%20-49.00539%2C33.59983%20-78.60717%2C33.59983%20-17.60277%2C0%20-42.99947%2C-5.603%20-76.19019%2C-16.8091%20l%20-11.40747%2C-4.1931%20c%20-13.19594%2C-4.4067%20-26.39783%2C-6.6101%20-39.60571%2C-6.6101%20-21.1915%2C0%20-42.98713%2C7.4036%20-65.38696%2C22.2107%20l%20-28.8025%2C-39.6057%20c%2040.79584%2C-35.20501%2064.79484%2C-65.40518%2071.99708%2C-90.60058%202.00185%2C-7.20202%203.00283%2C-14.80089%203.00292%2C-22.79664%20-9e-5%2C1.5e-4%20-9e-5%2C-0.20127%200%2C-0.60424%20l%200%2C-0.60425%20c%20-9e-5%2C-15.19759%20-4.80355%2C-30.79816%20-14.4104%2C-46.80176%20l%20-65.991206%2C0%200%2C-32.9956%2048.596196%2C0%20c%20-18.39605%2C-30.39526%20-28.59501%2C-52.19089%20-30.59693%2C-65.38697%20-0.8057%2C-3.60078%20-1.20853%2C-7.60468%20-1.20849%2C-12.01172%20l%200%2C-6.00586%20c%20-4e-5%2C-39.59926%2016.00336%2C-71.99669%2048.01025%2C-97.19238%2026.4037%2C-20.80035%2057.80015%2C-31.20073%2094.18945%2C-31.20117%20l%200.60425%2C0%20c%2045.20242%2C4.4e-4%2080.20604%2C14.80145%20105.01099%2C44.40308%20l%2010.19897%2C14.99633%20c%2010.79072%2C18.39636%2016.38763%2C44.99545%2016.79077%2C79.79737%20l%20-52.7893%2C0%20c%20-1.59938%2C-61.59632%20-28.80272%2C-92.39463%20-81.61011%2C-92.39502%20-35.59584%2C3.9e-4%20-60.59582%2C12.59803%20-75%2C37.79297%20-6.39658%2C11.20639%20-9.59482%2C24.01156%20-9.59473%2C38.41552%20l%200%2C0.58594%20c%20-9e-5%2C15.21026%204.40054%2C31.21366%2013.20191%2C48.01025%20l%200%2C0.60425%200.60424%2C0.58594%20c%201.59902%2C3.60134%203.79629%2C8.00197%206.5918%2C13.2019%20l%205.40161%2C9.00879%209.59473%2C16.79078%20z%22%20%2F%3E%3C%2Fg%3E%0A%3C%2Fsvg%3E'
            })
            this.$store.commit('addUnseenInvoice')
        }
        if(this.application) {
          this.$snotify.success("Your application to " + this.application.owner.name + " has been submitted. You will be contacted again after it is reviewed.", "Application Submitted", {
            timeout: 30000,
            icon: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23ffffff%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M16%204h2a2%202%200%200%201%202%202v14a2%202%200%200%201-2%202H6a2%202%200%200%201-2-2V6a2%202%200%200%201%202-2h2%22%2F%3E%0A%20%20%20%20%3Crect%20x%3D%228%22%20y%3D%222%22%20width%3D%228%22%20height%3D%224%22%20rx%3D%221%22%20ry%3D%221%22%2F%3E%0A%3C%2Fsvg%3E%0A'
          })
        }
        if(responseData.length > 1) {
          url = url + '?highlight='
          responseData.forEach(v => {
            url = url + v.id + ','
          })
          if(invoiceId) {
            url = url + '&invoiceId=' + invoiceId
          }
        } else if(!this.$store.getters.isNonApplicantIndividual) {
          url = url + '/' + (responseData.length == 1 ? responseData[0].id : responseData.id)
          if(invoiceId) {
            url = url + '?invoiceId=' + invoiceId
          }
        }
        this.$router.push(url)
      }
    },
    beforeRouteLeave (to, from, next) {
      if(to && (to.query.expired == 'true' || to.name == 'Login')) {
        next()
      } else if(this.verification.firstname
        || this.verification.middlename
        || this.verification.lastname
        || this.verification.dob
        || this.verification.customerReference
        || this.verification.institute
        || this.verifications.length > 0) {
          this.$modal.show(ModalOptions,
          {
            title: "Unsaved Verification",
            message: "Your Verification has not yet been saved, if you change pages your request will be lost.",
            message2: "Do you want to continue or discard this request?",
            closeText: "Discard",
            actionText1: "Continue",
            closeAction: () => 
              {
                this.resetSavedData()
                this.$modal.close()
                next()
              },
            action1: () => 
              {
                this.$modal.close()
              }
            }
          )
        } else {
          next()  
        }
    }
  }
</script>